export default {
  title: 'License Manager'
};
